import { c as _c } from "react/compiler-runtime";
import { FormSelect, Hint } from '@systemeio/ui';
import { WrapperChildrenPropsInterface } from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import { TriggerCourseItemProps } from 'modules/automation-rules/triggers/components/edit-triggers/components/trigger-course-item/index';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggerCourseEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { AutomationRuleBaseDataInterface } from 'modules/automation-rules/types/automation-rule-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import { CourseId } from 'modules/courses/courses/types/course-interface';
import { getCourseCurriculumUrl } from 'modules/courses/courses/utils/get-course-curriculum-url';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { OpenInNewIcon } from '@systemeio/ui/icons';
interface CourseSelectProps extends Omit<TriggerCourseItemProps, 'onDelete' | 'triggers' | 'setRules' | 'idx' | 'trigger'>, Pick<WrapperChildrenPropsInterface, 'renderTriggerLabel' | 'onOpen'> {
  onChange: (data?: number) => void;
  courseId?: CourseId;
  triggerId: number;
  course: TriggerCourseEditInterface['course'];
  courseData?: AutomationRuleBaseDataInterface[];
  hint?: string;
}
const CourseSelect = t0 => {
  const $ = _c(31);
  const {
    errors,
    renderTriggerLabel,
    onOpen,
    onChange,
    courseId,
    triggerId,
    courseData,
    course,
    hint,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== onOpen) {
    t1 = () => onOpen(AutomationRuleTriggersDataEnum.course);
    $[0] = onOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== courseId || $[3] !== hint || $[4] !== renderTriggerLabel || $[5] !== t) {
    let t3;
    if ($[7] !== courseId) {
      t3 = courseId && <LinkWithoutPrefetch href={getCourseCurriculumUrl({
        courseId
      })} rel="noreferrer" target="_blank" className="group self-center outline-hidden"><OpenInNewIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary" /></LinkWithoutPrefetch>;
      $[7] = courseId;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[9] !== hint) {
      t4 = hint && <Hint label={hint} />;
      $[9] = hint;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] !== t3 || $[12] !== t4) {
      t5 = <div className="flex items-center gap-1">{t3}{t4}</div>;
      $[11] = t3;
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    t2 = renderTriggerLabel({
      label: t("dashboard.courses.title"),
      additionalLabel: t5
    });
    $[2] = courseId;
    $[3] = hint;
    $[4] = renderTriggerLabel;
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[14] !== t) {
    t3 = t("dashboard.automation_rule.choose_course");
    $[14] = t;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== course) {
    t4 = getDataFromObj(course);
    $[16] = course;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== errors.automationTriggers || $[19] !== triggerId) {
    t5 = errors.automationTriggers[triggerId]?.course?.join("");
    $[18] = errors.automationTriggers;
    $[19] = triggerId;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== courseData || $[22] !== courseId || $[23] !== isStatic || $[24] !== onChange || $[25] !== t1 || $[26] !== t2 || $[27] !== t3 || $[28] !== t4 || $[29] !== t5) {
    t6 = <FormSelect disabled={isStatic} onOpen={t1} label={t2} placeholder={t3} value={courseId} staticData={t4} data={courseData} onChange={onChange} error={t5} />;
    $[21] = courseData;
    $[22] = courseId;
    $[23] = isStatic;
    $[24] = onChange;
    $[25] = t1;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  return t6;
};
export default CourseSelect;